import React, { useState } from 'react';
import { useSelector } from "react-redux";
import QuizFooterLoader from "./../Loader/QuizFooterLoader";
import { useTranslations, useStyles } from "examsbook-react-sdk/custom-hooks";
import CheckScoreModal from "../CheckScoreModal/checkScoreModal";

/**
 * QuizFooter
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizFooter(props) {
    const { isLoading, viewMode, hideNext, handleClick, drawerToggle, hidePrev, handleQuizPauseChange } = props;
    const quiz = useSelector((state) => state.quiz);
    const { duration, timeTaken } = quiz;
    const t = useTranslations();
    const selectedQuestion = useSelector((state) => state.selectedQuestion);
    const markButtonActive = selectedQuestion ? selectedQuestion.marked : false;
    const classes = useStyles(styles)();
    const questions = useSelector((state) => state.quiz.questions);
    const [ openScoreModel, setOpenScoreModel ] = useState(false);

    function handlerOpenCheckScore() {
        setOpenScoreModel(true);
    }

    function handlerCloseCheckScore() {
        setOpenScoreModel(false);
    }

    const isAnswered = selectedQuestion.answered;
    return (
        !isLoading ?
            <React.Fragment>
                <CheckScoreModal viewMode={viewMode} open={openScoreModel} questions={questions}
                                 handlerCloseCheckScore={handlerCloseCheckScore} duration={duration}
                                 timeTaken={timeTaken}/>
                <div className={`${classes.quizFooter} ${drawerToggle ? classes.quizFooterExpand : null}`}>

                    {viewMode ?
                        <div className={markButtonActive ? classes.scorebtn + ' ' + classes.active : classes.scorebtn}>
                            <span className={classes.markForReview + ' ' + classes.checkScore}
                                  onClick={handlerOpenCheckScore}>Your Score</span>
                        </div> : ''}

                    <div className={classes.prevNextBtns}>
                        {!hidePrev ?
                            <span className={classes.prevBtn}
                                  onClick={() => {
                                      handleClick('prev');
                                      handleQuizPauseChange(false);
                                  }}>
                                  <i className="fa fa-arrow-left"/>
                            </span> :
                            <span className="prev disabled" style={{ left: 0, position: "absolute" }}></span>
                        }
                        {(viewMode) && hideNext ? "" : <span
                            className={(viewMode || hideNext || isAnswered) ? classes.nextBtn : classes.nextBtn + ' ' + classes.skipBtn}
                            onClick={() => {
                                handleClick('next');
                                handleQuizPauseChange(false);
                            }}>
                        {!hideNext ? (isAnswered ? t('Next') : t('SKIP')) : t('Submit')} <i
                            className="fa fa-arrow-right"/></span>}
                    </div>
                </div>
            </React.Fragment> : <div className={classes.quizFooter}>
                <QuizFooterLoader/>
            </div>
    );
}

const styles = theme => ({
    quizFooter: {
        height: 44,
        position: 'fixed',
        bottom: 10,
        right: 30,
        left: 340,
        color: '#fff',
        transition: '0.3s all linear',
        padding: 0,
        overflow: 'hidden',
        zIndex: 999,
        backgroundColor: '#fff',
        display: 'inline-block',
        textAlign: 'center',
        borderRadius: 0,
        '@media (max-width:767px)': {
            bottom: 15,
            right: 0,
            left: '0 !important',
            borderRadius: 0,
            display: 'flex !important',
            justifyContent: 'space-between',
            backgroundColor: 'transparent',
            padding: '0 0 10px',
        },
        '@media (min-width:768px) and (max-width:1024px)': {
            left: '30px !important',
            zIndex: '9 !important'
        }
    },
    quizFooterExpand: {
        left: 60
    },
    markBtn: {
        float: 'none',
        width: 'auto',
        textAlign: 'left',
        backgroundColor: '#fff',
        display: 'inline-block',
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
        }
    },
    scorebtn: {
        float: 'none',
        width: 'auto',
        textAlign: 'left',
        backgroundColor: '#fff',
        display: 'inline-block',
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
            display: 'none'
        }
    },
    active: {
        ConvolverNode: '#0b2f8a',
        '& span': {
            color: '#fff',
        }
    },
    markForReview: {
        width: 'auto',
        display: 'inline-block',
        padding: 14,
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        textAlign: 'center',
        fontSize: 14,
        marginLeft: 0,
        cursor: 'pointer',
        fontWeight: 600,
        color: '#0039cb',
        '@media (max-width:767px)': {
            paddingLeft: 0,
            padding: 0,
            paddingRight: 0,
            fontSize: 13,
        }
    },
    checkScore: {
        display: 'none',
        '@media (max-width:767px)': {
            display: 'block'
        }
    },

    prevNextBtns: {
        float: 'right',
        width: 'auto',
        textAlign: 'right',
        backgroundColor: '#fff',
        '@media (max-width: 767px)': {
            backgroundColor: 'transparent',
            width: '100%',
            padding: '0 10px',
        }
    },
    prevBtn: {
        display: 'inline-block',
        padding: 10,
        paddingLeft: 20,
        paddingRight: 20,
        textAlign: 'center',
        fontSize: 16,
        cursor: 'pointer',
        color: '#000',
        position: 'absolute',
        left: 0,
        fontWeight: 'bold',
        background: '#eee',
        borderRadius: 4,
        width: '180px',
        '&:hover': {
            color: '#000',
            cursor: 'pointer'
        },
        '@media (max-width:767px)': {
            padding: 12,
            paddingLeft: 15,
            paddingRight: 15,
            fontSize: 16,
            position: 'static',
            width: '26%',
            marginRight: 'auto',
            float: 'left',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 44
        }
    },
    nextBtn: {
        display: 'inline-block',
        padding: 10,
        paddingLeft: 20,
        paddingRight: 20,
        textAlign: 'center',
        fontSize: 16,
        cursor: 'pointer',
        borderRadius: 4,
        color: '#fff',
        fontWeight: 'bold',
        position: 'absolute',
        background: '#00BFA5',
        right: 0,
        width: '180px',
        '& i': {
            marginLeft: 5,
            position: 'relative',
            top: -1
        },
        '&:hover': {
            color: '#fff',
            cursor: 'pointer'
        },
        '@media (max-width:767px)': {
            padding: 12,
            paddingLeft: 15,
            paddingRight: 15,
            fontSize: 16,
            position: 'static',
            width: '70%',
            marginRight: 0,
            marginLeft: 'auto',
            float: 'right',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 44
        },
    },
    skipBtn: {
        color: '#000',
        background: '#eee',
        '&:hover': {
            color: '#000 !important'
        }
    },
    disabled: {
        pointerEvents: 'none',
        color: '#888F96',
        '& i': {
            opacity: 0.5
        }
    }
});
export default QuizFooter;
